import type { init } from "@sentry/vue";

type DataCollection = NonNullable<Parameters<typeof init>[0]>["dataCollection"];

export const VALID_APP_DOMAINS = [
    "https://autoq.luv.polargold.dev",
    "https://autoq-stage.lehvoss.de",
    "https://autoq.lehvoss.de"
];
const IP_AND_USER_HEADER_DENYLIST = { deny: ["forwarded", "-ip", "remote-", "via", "-user"] };

/**
 * Explicit baseline that reproduces the restrictive `sendDefaultPii: false` behaviour of
 * `@sentry/vue` 10 (taken from Sentry's v10 -> v11 migration guide). Leaving `dataCollection`
 * unset in v11 enables much broader collection, so it must stay set.
 */
export const SENTRY_DATA_COLLECTION = {
    userInfo: false,
    cookies: false,
    httpHeaders: {
        request: IP_AND_USER_HEADER_DENYLIST,
        response: IP_AND_USER_HEADER_DENYLIST
    },
    httpBodies: [],
    urlQueryParams: IP_AND_USER_HEADER_DENYLIST,
    genAI: { inputs: false, outputs: false },
    databaseQueryData: false,
    queues: false,
    graphQL: { document: false, variables: false }
} satisfies DataCollection;
